var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"py-2 scrollable-block"},_vm._l((_vm.chips),function(item,index){return _c('v-chip',{key:index,attrs:{"small":"","close":"","disabled":_vm.disabled},on:{"input":function($event){return _vm.clearItem(item)}}},[_vm._v("\n    "+_vm._s(item.title)+": "+_vm._s(_vm.formatFilterValue(item))+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }